import { cn } from "@/lib/utils";

export type BrandLogoVariant = "full" | "iso";

const SOURCES: Record<BrandLogoVariant, { light: string; dark: string }> = {
  full: {
    light: "/brand/gestionalo-logo.svg",
    dark: "/brand/gestionalo-logo-white.svg",
  },
  iso: {
    light: "/brand/gestionalo-iso.svg",
    dark: "/brand/gestionalo-iso-white.svg",
  },
};

interface BrandLogoProps {
  variant: BrandLogoVariant;
  className?: string;
  imgClassName?: string;
}

export function BrandLogo({ variant, className, imgClassName }: BrandLogoProps): JSX.Element {
  const { light, dark } = SOURCES[variant];
  return (
    <span className={cn("inline-flex shrink-0 items-center", className)}>
      <img
        src={light}
        alt="Gestionalo"
        className={cn("dark:hidden", imgClassName)}
      />
      <img
        src={dark}
        alt="Gestionalo"
        className={cn("hidden dark:block", imgClassName)}
      />
    </span>
  );
}
